import React, { useState, useEffect } from 'react'
import moment from 'moment'
import Slider from 'react-slick'
import { useRouter } from 'next/router'

import { getUserSchedulings } from 'src/services/schedulingService'

import { ServiceScheduleContextProvider, useServiceScheduleContext, actionTypes } from 'src/context/serviceScheduleContext'
import withRootContext from 'src/context/withRootContextHOC'

import Button from 'src/components/button'
import WarningModal from 'src/components/warningModal'

import { assetPrefix } from 'src/config/env_config'

import { PAGE_URL, getPetPhotoByType, getServiceIconByName } from 'src/utils'
import MODAL from 'src/utils/modals'

import {
  INITIAL_CALENDAR_DATE,
} from '../../utils/schedulingConstants'

import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import * as Gs from 'src/styles/global'
import * as S from './styles'

const LastSchedulingsCarousel = ({ context, category = '', petsData: pets }) => {
  const { state, functions, dispatch } = useServiceScheduleContext()
  const { petsData: schedulingStatePets, modal } = state
  const { handleEditExternalScheduling } = functions
  const [schedulingData, setSchedulingData] = useState([])
  const router = useRouter()
  const petsData = pets || schedulingStatePets

  const repeatScheduling = async (scheduling) => {
    context.showLoader()
    const withoutDate = true

    const schedulingInfo = Array(scheduling).map(({ date, pet, professional, service, additionalServices, partner, status, payStatus, obs, id, rated, externalCoupon, campaign }) => {
      const localizedDate = moment(date).locale('pt-BR')
      const time = localizedDate.format('HH:mm')
      const day = localizedDate.format('DD/MM/YY - ddd')
      const additionalServicesScheduled = additionalServices?.map(service => service.name).join(', ')
      const professionalName = professional.name.split('CNPJ')[0]
      const professionalCNPJ = professional.cnpj
      const partnerPhone = partner.phone
      const localization = `${partner.fantasyName} - ${partner.address}`
      return ({
        id,
        pet,
        day,
        time,
        additionalServices: additionalServicesScheduled,
        professionalId: professional.id,
        professionalName,
        professionalCNPJ,
        partner: localization,
        partnerPhone,
        partnerId: partner.id,
        partnerFantasyName: partner.fantasyName,
        payStatus,
        obs,
        coupon: externalCoupon,
        status,
        rated,
        service,
        campaign
      })
    })?.[0]

    const newState = await handleEditExternalScheduling({ context }, schedulingInfo, withoutDate)

    window.localStorage.removeItem('schedulingState')

    if (newState?.reeschedulingError) {
      const stepToRedirect = {
        1: PAGE_URL.SCHEDULING_PET_AND_SERVICES,
        2: PAGE_URL.SCHEDULING_LOCATION,
        4: PAGE_URL.SCHEDULING_PROFESSIONAL
      }

      dispatch({
        type: actionTypes.UPDATE_STATE,
        payload: {
          modal: MODAL.STEP_UPDATE(
            () => {
              dispatch({
                type: actionTypes.UPDATE_STATE,
                payload: newState
              })

              router.push({
                pathname: stepToRedirect?.[newState?.activeStep],
                query: {
                  id: schedulingInfo?.id,
                  category: schedulingInfo?.service?.category
                }
              })

              dispatch({
                type: actionTypes.UPDATE_STATE,
                payload: {
                  modal: undefined
                }
              })
            },
            () => {
              router.push({
                pathname: PAGE_URL.SCHEDULING_INDEX
              })

              dispatch({
                type: actionTypes.UPDATE_STATE,
                payload: {
                  modal: undefined
                }
              })
            }
          )
        }
      })

      context.hideLoader()
      return
    }

    dispatch({
      type: actionTypes.UPDATE_STATE,
      payload: {
        modal: MODAL.REPEAT_SCHEDULE_DATE_SELECTION(
          () => {
            window.localStorage.removeItem('schedulingState')
            window.localStorage.removeItem('paymentState')

            dispatch({
              type: actionTypes.UPDATE_STATE,
              payload: {
                ...newState,
                calendarMonth: INITIAL_CALENDAR_DATE.calendarMonth,
                calendarYear: INITIAL_CALENDAR_DATE.calendarYear,
                modal: undefined
              }
            })

            router.push({
              pathname: PAGE_URL.SCHEDULING_DATE,
              query: {
                id: schedulingInfo?.id,
                category: schedulingInfo?.service?.category
              }
            })
          },
          () => {
            router.push({
              pathname: PAGE_URL.SCHEDULING_INDEX
            })

            dispatch({
              type: actionTypes.UPDATE_STATE,
              payload: {
                modal: undefined
              }
            })
          }, {
          service: schedulingInfo?.service?.name,
          partner: schedulingInfo?.partner?.split('-')?.[0],
          professional: schedulingInfo?.professionalName
        }
        )
      }
    })

    context.hideLoader()
  }

  const handleRedirectToDiary = () => {
    router.push({
      pathname: PAGE_URL.SCHEDULING_INDEX,
      query: {
        tab: 'agenda',
      }
    })
  }

  const slickOptions = {
    variableWidth: true,
    dots: true,
    arrows: false,
    infinite: false,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1
        }
      },
      {
        breakpoint: 575,
        settings: {
          slidesToShow: 1,
          centerMode: true
        }
      },
      {
        breakpoint: 413,
        settings: {
          slidesToShow: 1,
          centerMode: false
        }
      }
    ]
  }

  const serviceSVG = {
    'Banho': 'bath-outline.svg',
    'Banho&Tosa Trimming': 'bath-shear-solid.svg',
    'Banho&Tosa Máquina': 'bath-shear-outline.svg',
    'Banho&Hidratação': 'bath-new-solid.svg',
    'Banho&Tosa Tesoura': 'bath-scissors-solid.svg',
    'Banho&Tosa Higiênica': 'bath-higienic.svg',
    'Atendimento Atestado de Saúde': 'health-certificate-outline.svg',
    'Consulta Dermatológica': 'paw-new-outline.svg',
    'Consulta na Clinica': 'doctor-new-outline.svg',
    'Vacina': 'vaccine-new-outline.svg'
  }

  useEffect(() => {
    const handleGetUserSchedulings = async () => {
      const { schedulings, totalItems } = await getUserSchedulings({
        skip: 0,
        limit: 10,
        status: 'FINISHED',
        ...(category && { category })
      })

      if (totalItems === 0) {
        setSchedulingData([])
        return
      }


      const schedulingsWithPhoto = schedulings?.map(item => {
        if (!petsData?.length) {
          return item
        }

        const photo = petsData?.find(({ id }) => id === item.pet.id)?.photo
        return ({ ...item, pet: { ...item.pet, photo } })
      })

      setSchedulingData(schedulingsWithPhoto)
    }

    if (
      context.firstName &&
      (router.query?.showDiary == 'true' && router.pathname?.includes(PAGE_URL.SCHEDULING_PET_AND_SERVICES)) ||
      router.pathname === PAGE_URL.SCHEDULING_INDEX
    ) {

      handleGetUserSchedulings()
    }
  }, [router.query?.showDiary, context.firstName])

  if (!schedulingData.length) {
    return (<></>)
  }

  const isHome = !category

  return (
    <>
      <Gs.WrapperFormAndCard>
        <S.WrapperForm noMargin={isHome}>
          <S.AlignWrappers noMargin>
            <S.WrapperTitle isPet firstContainer={!isHome} isHome={isHome}>
              <span>Repetir o último serviço realizado</span>
            </S.WrapperTitle>

            <S.WrapperCards>
              <Slider {...slickOptions}>
                {[...schedulingData, { isHistory: true }]?.map(
                  (item, key) => (
                    <div key={key}>
                      {item?.isHistory ? (
                        <S.Link onClick={() => handleRedirectToDiary()}>
                          Ver histórico
                        </S.Link>
                      ) : (
                        <S.ScheduleCard>
                          <S.SchedulingPetName>
                            <S.Photo
                              src={item?.pet?.photo || getPetPhotoByType(item?.pet?.breed?.type)}
                              setDefaultPhoto={!item?.pet?.photo}
                              size='40px'
                              mobileSize='40px'
                            />

                            <span>
                              {item?.pet?.name}
                            </span>
                          </S.SchedulingPetName>

                          <S.SchedulingInfo>
                            <S.Icon src={`${assetPrefix}/static/icons/${serviceSVG[item?.service?.name?.match(/Vacina/) ? 'Vacina' : item?.service?.name]}`} />
                            <span>
                              {item?.service?.name}
                            </span>
                          </S.SchedulingInfo>

                          {item?.additionalServices?.map(service => {
                            const additionalServiceIcon = getServiceIconByName(service?.name)

                            return (
                              <S.SchedulingInfo>
                                <S.Icon src={additionalServiceIcon} />

                                <span>
                                  {service?.name}
                                </span>
                              </S.SchedulingInfo>
                            )
                          })}

                          <S.SchedulingInfo>
                            <S.Icon location src={`${assetPrefix}/static/icons/map-marker-alt.svg`} />

                            <span>
                              {item?.partner?.fantasyName}
                            </span>
                          </S.SchedulingInfo>

                          <S.SchedulingInfo>
                            <S.Icon src={`${assetPrefix}/static/icons/professional-outlined.svg`} />

                            <span>
                              {item?.professional?.name?.split('CNPJ')?.[0]}
                            </span>
                          </S.SchedulingInfo>

                          <Button height='32px' fontSize='1.2rem' margin='8px 0 0'color="var(--cobasi-blue-light-9)" onClick={() => repeatScheduling(item)}>
                            <S.Icon size='16px' src={`${assetPrefix}/static/icons/horizontal-loading.svg`} />
                            Repetir agendamento
                          </Button>
                        </S.ScheduleCard>
                      )}
                    </div>
                  )
                )}
              </Slider>
            </S.WrapperCards>
          </S.AlignWrappers>
        </S.WrapperForm>
      </Gs.WrapperFormAndCard>

      <WarningModal
        visible={!!modal}
        cancelLabel={modal?.cancelLabel}
        confirmLabel={modal?.confirmLabel}
        type={modal?.type}
        title={modal?.title}
        subtitle={modal?.subtitle}
        onConfirm={modal?.onConfirm}
        onCancel={modal?.onCancel}
        fullButton={modal?.fullButton}
        outlineCancelButton={modal?.outlineCancelButton}
        showClose={modal?.showClose}
        icon={modal?.icon ? modal?.icon : !modal?.professional ? `${assetPrefix}/static/icons/warning.svg` : ''}
        iconSize={modal?.iconSize}
        dataTest='modal-warning-scheduling'
        titleSize={modal?.titleSize}
      >
        {modal?.body}
      </WarningModal>

    </>
  )
}

const WrapedComponent = (props) => (
  <ServiceScheduleContextProvider>
    <LastSchedulingsCarousel {...props} />
  </ServiceScheduleContextProvider>
)

export default withRootContext(WrapedComponent)
